import { useForm, Controller } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Form, Input, Button } from 'antd';
import { trpc } from '../../../utils/trpc';
import Modal from '../../common/components/Modal';
import React from 'react';
import { schema } from './NewClientForm';

interface Props {
  clientId: string;
  defaultValues: {
    name: string;
    shortName: string;
    quickbooksCustomerName: string;
  };
}
// @ts-ignore
const EditClientForm = ({ clientId, defaultValues }: Props) => {
  const [showModal, setShowModal] = React.useState(false);
  const editMutation = trpc.useMutation(['client.edit']);
  const utils = trpc.useContext();

  const {
    handleSubmit,
    reset,
    control,
    formState: { errors, isDirty },
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues,
  });

  return (
    <div>
      <Button
        onClick={() => {
          setShowModal(true);
        }}
      >
        Edit
      </Button>
      {/* @ts-ignore */}
      <Modal
        title="Edit Client"
        visible={showModal}
        destroyOnClose={true}
        forceRender={true}
        onCancel={() => {
          setShowModal(false);
          reset();
        }}
        footer={
          <div>
            <Button
              onClick={() => {
                setShowModal(false);
                reset();
              }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              disabled={!isDirty}
              loading={editMutation.isLoading}
              onClick={handleSubmit(({ name, shortName, quickbooksCustomerName }) => {
                editMutation.mutate(
                  {
                    id: clientId,
                    name,
                    shortName,
                    quickbooksCustomerName,
                  },
                  {
                    onSuccess: () => {
                      setShowModal(false);
                      reset();
                      utils.invalidateQueries(['client.all']);
                    },
                    onError: e => {
                      console.log(e);
                    },
                  },
                );
              })}
            >
              Submit
            </Button>
          </div>
        }
      >
        <form className="flex flex-wrap transition-opacity">
          <Form.Item
            className="w-full md:w-1/2 p-2"
            label="Name"
            hasFeedback
            validateStatus={errors.name?.message && 'error'}
            help={errors.name?.message}
          >
            <Controller
              name="name"
              control={control}
              render={({ field }) => <Input {...field} />}
            />
          </Form.Item>
          <Form.Item
            className="w-full md:w-1/2 p-2"
            label="Short Name"
            hasFeedback
            validateStatus={errors.shortName?.message && 'error'}
            help={errors.shortName?.message}
          >
            <Controller
              name="shortName"
              control={control}
              render={({ field }) => <Input {...field} />}
            />
          </Form.Item>
          <Form.Item
            className="w-full md:w-1/2 p-2"
            label="Customer Name"
            hasFeedback
            validateStatus={errors.quickbooksCustomerName?.message && 'error'}
            help={errors.quickbooksCustomerName?.message}
          >
            <Controller
              name="quickbooksCustomerName"
              control={control}
              render={({ field }) => <Input {...field} />}
            />
          </Form.Item>
        </form>
      </Modal>
    </div>
  );
};

export default EditClientForm;
